// extracted by mini-css-extract-plugin
export default {"wrapper":"TipPreviews_wrapper__Ngnig","title":"TipPreviews_title__KqMHO","list":"TipPreviews_list__aKaeb","li":"TipPreviews_li__hipGn"};